import { FC, ReactNode } from "react";

// redux
import {
  deleteNotification,
  fetchNotificationsCount,
  readNotification,
  restoreNotification
} from "redux/thunks/notifications.thunk";
import { useDispatch } from "react-redux";

// components
import { Dropdown, MenuProps } from "antd";

// icons
import { ReactComponent as MenuIcon } from "assets/icons/three_dots_icon.svg";

// style
import css from "./style.module.scss";

// types
import { NotificationType } from "notifications/types";
import { AppDispatch } from "redux/store/store";
import { handleError } from "utils/handleError";

interface INotification {
  notification: NotificationType;
}

const Notification: FC<INotification> = ({ notification }) => {
  const dispatch = useDispatch<AppDispatch>();

  const readNotificationHandler = (url?: string): Promise<void> => {
    return dispatch(readNotification(notification.id))
      .then((): void => {
        dispatch(fetchNotificationsCount());
      })
      .then((): void => {
        if (url) {
          document.location.href = url;
        }
      })
      .catch((error): void => handleError("Ошибка при чтении уведомления", error));
  };

  const deleteNotificationHandler = (): void => {
    dispatch(deleteNotification(notification.id))
      .then((): void => {
        dispatch(fetchNotificationsCount());
      })
      .catch((error): void => handleError("Ошибка при удалении уведомления", error));
  };

  const restoreNotificationHandler = (): void => {
    dispatch(restoreNotification(notification.id))
      .then((): void => {
        dispatch(fetchNotificationsCount());
      })
      .catch((error) => handleError("Ошибка при восстановлении уведомления", error));
  };

  const renderNotificationActions = (): ReactNode => {
    const switchNotificationHandler = (): void => {
      notification.is_read
        ? restoreNotificationHandler()
        : readNotificationHandler();
    };

    const items: MenuProps["items"] = [
      {
        label: <a>{`${notification.is_read ? "Отметить непрочитанным" : "Отметить прочитанным"}`}</a>,
        key: `${notification.id}${notification.is_read ? "_restore" : "_read"}`,
        onClick: switchNotificationHandler,
      },
      {
        label: <a style={{ color: "#FF4D4F" }}>Удалить</a>,
        key: `${notification.id}_delete`,
        onClick: deleteNotificationHandler,
      },
    ];

    return (
      <Dropdown menu={{ items }} trigger={["click"]}>
        <MenuIcon className="cursor-pointer secondary-color" />
      </Dropdown>
    );
  };

  const onClickHandler = (): void => { readNotificationHandler(notification.payload.redirectUrl); };

  return (
    <div className="notification_wrapper">
      <div className="flex flex-row items-center justify-between mb-1">
        <div className="time_wrapper flex flex-row items-center ">
          {!notification.is_read && <div className={`${css.dot_indicator} mr-1.5`}></div>}
          <p className="ghost">{new Date(notification.created_at).toLocaleString()}</p>
        </div>
        {renderNotificationActions()}
      </div>
      <a onClick={onClickHandler}>
        <p className={`${css.header_text} mb-2`}><strong>{notification.message}</strong></p>

        {notification?.payload?.subject && (
          <p className="ghost"> {notification?.payload?.subject}</p>
        )}
      </a>
    </div >
  );
};

export default Notification;